import { GenericRefModel } from './CommonModel';
import { JsonSchemaModel } from './JsonSchemaModel';

export type SchemaValueModel = GenericRefModel & {
	Value: JsonSchemaModel;
};

export type SchemaValueReferenceModel = { SchemaValueId: string };
export type SchemaValueBindingModel = SchemaValueModel | SchemaValueReferenceModel;

export function isSchemaValueReference(value: SchemaValueBindingModel | undefined): value is SchemaValueReferenceModel {
	return !!value && 'SchemaValueId' in value;
}
